module.exports = __webpack_public_path__ + "static/img/testimony5.2f3a471.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/testimony5.png
// module id = wfg7
// module chunks = 1 3